import React, { useEffect, useRef, useMemo } from "react";

const AdCMP = ({ dataAdSlot, isTagNeeded = false, adSize = "" }) => {
    const adRef = useRef(null);

    const { width, height, adStyle } = useMemo(() => {
        if (!adSize) return { width: null, height: null, adStyle: {} };
        const [w, h] = adSize.split("x").map(Number);
        return {
            width: w,
            height: h,
            adStyle: w && h ? { width: `${w}px`, height: `${h}px` } : {}
        };
    }, [adSize]);

    useEffect(() => {
        const loadAd = () => {
            try {
                if (typeof window !== 'undefined' && window.adsbygoogle && adRef.current) {
                    (window.adsbygoogle = window.adsbygoogle || []).push({});
                }
            } catch (error) {
                // Silent error handling
            }
        };

        const timer = setTimeout(loadAd, 100);
        return () => clearTimeout(timer);
    }, [dataAdSlot]);

    return (
        <div
            className={`mx-auto flex flex-col items-center ${isTagNeeded ? "pt-1" : ""}`}
            style={{ 
                width: width ? `${width}px` : '100%',
                minHeight: height ? `${height}px` : 'auto',
                padding: '10px 0'
            }}
        >
            {isTagNeeded && (
                <p className="text-xs text-gray-500 mb-2">Advertisement</p>
            )}

            <ins
                className="adsbygoogle"
                style={{ display: "block", ...adStyle }}
                data-ad-client="ca-pub-8383910619750608"
                data-ad-slot={dataAdSlot}
                data-ad-format="auto"
                data-full-width-responsive="true"
                ref={adRef}
            ></ins>
        </div>
    );
};

export default AdCMP;
